import { themes } from 'kb-shared';
import styled from 'styled-components';
import { Container } from '../../../components/TextInput/NewTextInput';

export const FieldsRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-top: 20px;

  label {
    text-transform: uppercase;
  }
`;

export const SmallWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  width: 50%;

  @media screen and (max-width: ${themes.breakpoints.tabletPortrait}) {
    width: 100%;
  }
`;

export const Icon = styled.img`
  width: 23px;
  height: 23px;
  object-fit: contain;
  margin-right: 15px;
`;

export const Text = styled.span`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  color: ${themes.colors.KBNight};
  font-weight: bold;
  font-size: 18px;
`;

export const InputsLabel = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 12px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: self-start;
  width: 100%;
  margin-top: 20px;

  @media screen and (max-width: ${themes.breakpoints.tabletPortrait}) {
    flex-direction: column;
  }
`;

export const InputRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  ${Container} {
    margin-right: 20px;
  }

  ${SmallWrapper}:first-child {
    margin-right: 20px;
  }
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
`;
